import { Component, OnInit, Sanitizer } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css']
})
export class PrincipalComponent implements OnInit {

    constructor(private appService: AppService) { }

    ngOnInit() {
        this.getData();
        this.getRuchers();
        this.getRuches();
    }

    getData() {
        this.appService.chargerNomenclatures().subscribe(nomenclatures => {
            this.appService.nomenclatures = nomenclatures;
        });
    }

    getRuchers() {
        this.appService.getRuchers().subscribe(ruchers => {
            this.appService.ruchers = ruchers;
        });
    }

    getRuches() {
        this.appService.getRuches().subscribe(ruches => {
            this.appService.ruches = ruches;
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/principal/principal.component.ts